import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {tap} from 'rxjs/operators';
import { OktaAuthService } from 'src/app/services/auth.service';
import {Router} from '@angular/router';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
    accessToken:string;
    constructor(private oktaAuthService: OktaAuthService, private router: Router) {
        this.accessToken = this.oktaAuthService.getToken();
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      this.checkForTokenExpiry()
        request = request.clone({
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Authorization': 'Bearer ' + this.accessToken
              })
        })
        return next.handle(request).pipe( tap(() => {},
        (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
           return;
          }
          this.oktaAuthService.login(this.router.url);
        }
      }));
    }

    checkForTokenExpiry()
    {
      if(this.oktaAuthService.getToken()==undefined)
        {
      this.oktaAuthService.login(this.router.url);
      return;
        }
    }
}
